"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useUnload = function (fn) {
    var cb = react_1.useRef(fn);
    react_1.useEffect(function () {
        cb.current = fn;
    }, [fn]);
    react_1.useEffect(function () {
        var onUnload = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = cb.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([cb], args));
        };
        window.addEventListener('beforeunload', onUnload);
        return function () { return window.removeEventListener('beforeunload', onUnload); };
    }, []);
};
exports.default = useUnload;
